import { render } from "./DataCard.vue?vue&type=template&id=c9375ca8&scoped=true"
import script from "./DataCard.vue?vue&type=script&lang=js"
export * from "./DataCard.vue?vue&type=script&lang=js"

import "./DataCard.vue?vue&type=style&index=0&id=c9375ca8&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9375ca8"]])

export default __exports__